import {
  GET_EMAIL_TEMPLATES_LIST,
  EDIT_EMAIL_TEMPLATE,
  ADD_EMAIL_TEMPLATE,
  DELETE_EMAIL_TEMPLATE_REQUEST,
  EmailTemplate_GET_DETAILS
} from '../../constants/redux';

export const getEmailTemplatesList = (payload) => {
  return {
    type: GET_EMAIL_TEMPLATES_LIST,
    payload
  };
};

export const addEmailTemplate = (content) => {
  return {
    type: ADD_EMAIL_TEMPLATE,
    payload: content
  };
};

export const deleteTemplate = (ID) => {
  return {
    type: DELETE_EMAIL_TEMPLATE_REQUEST,
    payload: ID
  };
};

export const editEmailTemplate = (Details) => {
  return {
    type: EDIT_EMAIL_TEMPLATE,
    payload: Details
  };
};

export const getEmailTemplateById = (ID) => {
  return {
    type: EmailTemplate_GET_DETAILS,
    payload: ID
  };
};
